import { Link, useLocation } from 'react-router-dom';
import { useStorefront } from '@/context/StorefrontContext';

export function StorefrontContentPage() {
  const location = useLocation();
  const { pages, routes, brand } = useStorefront();
  const route = routes.find((item) => item.routePath === location.pathname);
  const page = pages.find((item) => item.pageKey === route?.targetKey || item.path === location.pathname);

  if (!page) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-16 text-center">
        <h1 className="text-3xl font-bold text-slate-900 mb-3">Page not available</h1>
        <p className="text-slate-500">This storefront page has not been published yet.</p>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto px-4 py-16 animate-fade-in">
      <div className="mb-10">
        <p className="text-sm font-semibold uppercase tracking-wide text-ocean-600 mb-2">{brand.brandShortName}</p>
        <h1 className="text-4xl font-bold text-slate-900 mb-3">{page.title ?? page.pageKey}</h1>
        {page.intro && <p className="text-lg text-slate-500 max-w-3xl">{page.intro}</p>}
      </div>

      <div className="space-y-8">
        {(page.sections ?? []).map((section, index) => {
          const type = String(section.type ?? 'text');
          if (type === 'feature-grid') {
            const items = Array.isArray(section.items) ? section.items as Array<Record<string, unknown>> : [];
            return (
              <section key={`${type}-${index}`} className="grid md:grid-cols-2 gap-5">
                {items.map((item, itemIndex) => (
                  <div key={`${type}-item-${itemIndex}`} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                    <h2 className="text-lg font-semibold text-slate-900 mb-2">{String(item.title ?? '')}</h2>
                    <p className="text-sm text-slate-500">{String(item.body ?? '')}</p>
                  </div>
                ))}
              </section>
            );
          }

          if (type === 'cta') {
            return (
              <section key={`${type}-${index}`} className="rounded-3xl bg-gradient-to-r from-brand-800 to-ocean-700 p-8 text-white">
                <h2 className="text-2xl font-semibold mb-3">{String(section.title ?? 'Next step')}</h2>
                <p className="text-white/75 mb-6">{String(section.body ?? '')}</p>
                <Link
                  to={String(section.primaryHref ?? '/contact')}
                  className="inline-flex items-center rounded-xl bg-white px-5 py-3 text-sm font-semibold text-brand-700 hover:bg-brand-50 transition-colors"
                >
                  {String(section.primaryLabel ?? 'Contact us')}
                </Link>
              </section>
            );
          }

          return (
            <section key={`${type}-${index}`} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
              <p className="text-sm text-slate-600">{String(section.body ?? '')}</p>
            </section>
          );
        })}
      </div>
    </div>
  );
}
